import { useMutation } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithPassword } from '../api/auth';
import { useAuthStore } from '../auth/auth-store';

// 簡易ログイン（email + password）。loginID 方式は廃止（社長指示 2026-06-09）。
export function LoginPage() {
  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: () => loginWithPassword(email, password),
    onSuccess: (data) => {
      setSession(data.accessToken, { displayName: email });
      navigate('/', { replace: true });
    },
    onError: (err: unknown) => {
      const msg = err instanceof Error ? err.message : 'ログインに失敗しました';
      setErrorMessage(msg);
    },
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);
    mutation.mutate();
  };

  return (
    <div className="k-login">
      {/* 左：ブランドパネル */}
      <aside className="k-login__brand">
        <div className="k-login__logo">
          <span className="k-login__logo-mark">K</span>
          <span>Konecco</span>
        </div>
        <div className="k-login__hero">
          <h2>AI Worker をひとつのチャットから。</h2>
          <p>
            チャンネルごとの AI ワーカーを集約し、指示・進捗・成果をまとめて管理。
            チームの業務をなめらかに前へ進めます。
          </p>
        </div>
        <div className="k-login__foot">© Konecco</div>
      </aside>

      {/* 右：フォーム */}
      <main className="k-login__panel">
        <form className="k-login__form" onSubmit={onSubmit}>
          <h1 className="k-login__title">サインイン</h1>
          <p className="k-login__sub">メールアドレスとパスワードでログインしてください。</p>

          <div className="k-field">
            <label htmlFor="login-email">メールアドレス</label>
            <input
              id="login-email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="k-field">
            <label htmlFor="login-password">パスワード</label>
            <input
              id="login-password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <button
            className="k-login__submit"
            type="submit"
            disabled={mutation.isPending || !email || !password}
          >
            {mutation.isPending ? 'サインイン中…' : 'サインイン'}
          </button>

          {errorMessage && <p className="k-error">{errorMessage}</p>}
        </form>
      </main>
    </div>
  );
}
